// extracted by mini-css-extract-plugin
module.exports = {"page":"account_page__1D3S6","pageTitle":"account_pageTitle__QqVH0"};